import React, { useEffect } from "react";
import styles from '../styles/uploadErrorImage.module.scss'
import ImageUploader, { ImageUploadItem } from "@/wmCompoments/imageUploader";
import Toast from "@/wmCompoments/toast";
import { useUploadImage } from "@/api/request";
import { useFormContext } from "react-hook-form";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
}

const UploadErrorImage = (props: Props) => {
    const { t } = useTranslation('feedback')
    
    const { name } = props

    const {
        register,
        setValue,
        watch,
        trigger,
        formState: { errors },
    } = useFormContext();

    const value = watch(name);

    // 注册字段及校验规则
    useEffect(() => {
        register(name);
    }, [register]);

    const { trigger: uploadImage } = useUploadImage()

    const beforeUpload = async (file: File) => {
        const isLt15MB = file.size / 1024 < 10 * 1000;
        if (!isLt15MB) {
            Toast.show(t('imageSizeLimit'))
            return null;
        }
        return file;
    };

    const upload = async (file: File): Promise<ImageUploadItem> => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('category', '2')
            formData.append('sensitive', '1')
            const res = await uploadImage(formData);
            return { url: res?.data?.fileUrl, name: res?.data?.fileUrl };
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
            return Promise.reject(error)
        }
    };

    const onDelete = async (item: ImageUploadItem) => {
        return Promise.resolve(true)
    };

    const onChange = (items: ImageUploadItem[]) => {
        setValue(name, items)
    }

    return <div className={styles.warpper}>
        <div>
            <span>{t('issueScreenshot')}</span>
            <span className={styles.desc}>{t('fileFormatLimit')}</span>
            <span className={styles.num}>{value?.length ?? 0}/3</span>
        </div>

        <ImageUploader
            maxCount={3}
            beforeUpload={beforeUpload}
            upload={upload}
            value={value}
            onDelete={onDelete}
            onChange={(items: ImageUploadItem[]) => onChange(items)}
            className={styles.imageUpload}
        />
    </div>
}


export default UploadErrorImage